import clsx from 'clsx'
import React, { FC } from 'react'

import styles from './CartLoading.module.scss'

interface Props {
  children?: React.ReactNode
  loading: boolean
  transparent?: boolean
}

export const CartLoading: FC<Props> = ({ children, loading, transparent }) => (
  <>
    {loading && (
      <div className={clsx(styles.cardLoading, transparent && styles.transparent)}>
        <div className={styles.spinner} />
      </div>
    )}
    {children}
  </>
)
